import { EventEmitter, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { InternalResponseInterface, WorldInfoInterface } from 'src/app/home/object-info/model/config-api-response.interface';import { UtilsService } from '../utils.service';
import { NamSelectedObjectService } from './nam-object-selected.service';
import { ProjectService } from './project.service';

@Injectable({
    providedIn: 'root'
})
export class WorldService {
    // World info of the currently selected feature.
    private worldInfo: WorldInfoInterface;
    public currentUrn: string = "";
    public onChange: EventEmitter<WorldInfoInterface> = new EventEmitter();

    constructor(
        private utils: UtilsService,
        private projectService: ProjectService,
        private selectedObjectService: NamSelectedObjectService
    ) {}

    async updateWorldMap(){
        this.fetchWorldInfo(this.currentUrn);
    }

    async fetchWorldInfo(featureUrn: string) {
        let url = this.utils.creaURL("feature", "internal");
        let params = {};
        this.currentUrn = featureUrn;
        params["urn"] = this.currentUrn;
        if(this.projectService.hasProject){
            params["project_id"] = this.projectService.projectId;
        }

        let result = await (this.utils.getRequest(url, params) as Observable<InternalResponseInterface>).toPromise();
        
        if (result.error == 0) {
            this.worldInfo = result.data;
          
            // Compute world size.
            let sizeX = this.worldInfo.bounds.xmax - this.worldInfo.bounds.xmin;
            let sizeY = this.worldInfo.bounds.ymax - this.worldInfo.bounds.ymin;
          
            // Enlarge bounds to make room for texts.
            if (!featureUrn.includes("mit_hub")) {
              this.worldInfo.bounds.xmin -= sizeX / 2;
              this.worldInfo.bounds.xmax += sizeX / 2;
            }
        } else {
            //There was an error creating the project.
            this.worldInfo = null;
        }

        // Remove highlight.
        if (this.selectedObjectService.highlightedObject) {
            this.selectedObjectService.deselectedObject = this.selectedObjectService.selectedObjectToHighlight;
        }

        this.onChange.emit(this.worldInfo);
    }

    getWorldInfo() {
        return this.worldInfo;
    }
}
